export const MOBILE_PATTERN = '[6-9][0-9]{9}'
const MOBILE_REGEX = /^[6-9]\d{9}$/

export function isValidMobile(value: string): boolean {
  return MOBILE_REGEX.test(value.trim())
}

/** Indian PIN codes are six digits and never start with 0. */
export const PINCODE_PATTERN = '[1-9][0-9]{5}'
const PINCODE_REGEX = /^[1-9]\d{5}$/

export function isValidPincode(value: string): boolean {
  return PINCODE_REGEX.test(value.trim())
}
